import { render, staticRenderFns } from "./addExpense.vue?vue&type=template&id=5b926858&scoped=true"
import script from "./addExpense.vue?vue&type=script&lang=js"
export * from "./addExpense.vue?vue&type=script&lang=js"
import style0 from "./addExpense.vue?vue&type=style&index=0&id=5b926858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b926858",
  null
  
)

export default component.exports